import Reveal from "@/components/Reveal";
import { HandCoins, Wallet, Briefcase, ShieldCheck } from "lucide-react";

const HIGHLIGHTS = [
  {
    icon: HandCoins,
    figure: "$500",
    label: "We Pay You",
    text: "Receive a $500 partnership incentive from Shonta Solutions when you join our qualifying property management program.",
    testid: "offer-highlight-500",
  },
  {
    icon: Wallet,
    figure: "80%",
    label: "You Keep",
    text: "You receive 80% of your property's monthly rental profits after agreed operating expenses.",
    testid: "offer-highlight-80",
  },
  {
    icon: Briefcase,
    figure: "20%",
    label: "We Earn",
    text: "Shonta Solutions receives 20% of monthly rental profits in exchange for coordinating the day-to-day management of your rental.",
    testid: "offer-highlight-20",
  },
];

export default function Partnership() {
  return (
    <section id="partnership" className="py-20 sm:py-28 bg-white" data-testid="partnership-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="text-center">
          <p className="text-sm font-bold tracking-[0.2em] uppercase text-[#FF5A5F]">Our Partnership Offer</p>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight text-[#222]">
            A Partnership That Pays You First
          </h2>
        </Reveal>

        <div className="mt-12 grid md:grid-cols-3 gap-6 sm:gap-8">
          {HIGHLIGHTS.map((h, i) => (
            <Reveal key={h.label} delay={i * 0.1}>
              <article
                data-testid={h.testid}
                className="h-full text-center bg-[#F7F7F9] border border-[#EBEBEB] rounded-2xl p-8 sm:p-10 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_24px_rgba(0,0,0,0.10)] hover:bg-white"
              >
                <span className="inline-flex w-14 h-14 rounded-2xl bg-[#FFD3C6]/60 items-center justify-center">
                  <h.icon className="w-7 h-7 text-[#E0484D]" />
                </span>
                <p className="mt-5 font-heading text-6xl font-extrabold tracking-tight text-[#FF5A5F]">{h.figure}</p>
                <p className="mt-2 text-sm font-extrabold tracking-[0.15em] uppercase text-[#222]">{h.label}</p>
                <p className="mt-4 text-[15px] leading-relaxed text-[#5a5a5a]">{h.text}</p>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-10">
          <div
            data-testid="offer-statement"
            className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-4 text-center bg-[#222222] rounded-2xl px-8 py-7"
          >
            <ShieldCheck className="w-8 h-8 text-[#FF5A5F] shrink-0" />
            <p className="text-base sm:text-lg font-bold text-white leading-relaxed">
              No Lease Required. No Daily Management Responsibilities.{" "}
              <span className="text-[#FFD3C6]">You Keep Ownership of Your Property.</span>
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
